// @flow
import { TeamSettingsReducerState } from 'common/models/internal/TeamSettingsReducerState';
import TeamSettingsActions from 'common/redux/actions/teamSettings';
import { TeamSettings } from 'common/models/internal/TeamSettings';
import * as Immutable from 'immutable';

const initialState = TeamSettingsReducerState.fromJS({});

export default (
    state: TeamSettingsReducerState = initialState,
    action: Object
) => {
    switch (action.type) {
        case TeamSettingsActions.FETCH_TEAM_SETTINGS_START:
            return state.setIsLoading(true);

        case TeamSettingsActions.FETCH_TEAM_SETTINGS_COMPLETE:
            return state.setIsLoading(false);

        case TeamSettingsActions.INJECT_TEAM_SETTINGS: {
            const teamSettings = TeamSettings.fromJS(action.response);
            const team = Immutable.fromJS(action.params);
            // Dont use Team.fromJS here as it ImmutableModel cannot be used as a key to a map
            const updatedTeamSettingsMap = state.teamSettingsMap.set(
                team,
                teamSettings
            );
            const updatedState = state
                .setIsLoading(false)
                .setTeamSettingsMap(updatedTeamSettingsMap);
            return updatedState;
        }

        default:
            return state;
    }
};
